/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description subjectsListUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamssubjectsListUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description subjectsSubjectIdAddArticlesUsingPost参数
 * @property `subjectId` 专题id
 */
export interface ParamssubjectsSubjectIdAddArticlesUsingPost {
  // pathParams
  /**
   * 专题id
   */
  subjectId: number;
}
/**
 * 文章id数组
 */
export type ParamsBodysubjectsSubjectIdAddArticlesUsingPost = Array<number>;
/**
 * @description subjectsSubjectIdArticlesUsingGet参数
 * @property `subjectId` 专题id
 * @property `[classifyId]` 分类id 获取全部传0
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `[tagId]` 标签id
 * @property `[type]` 最热类型/最新类型 最热->HOT 最新->LATEST
 */
export interface ParamssubjectsSubjectIdArticlesUsingGet {
  // pathParams
  /**
   * 专题id
   */
  subjectId: number;
  // queryParams
  /**
   * 分类id 获取全部传0
   */
  classifyId?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 标签id
   */
  tagId?: number;
  /**
   * 最热类型/最新类型 最热->HOT 最新->LATEST
   */
  type?: string;
}
/**
 * @description subjectsSubjectIdDeleteArticlesUsingDelete参数
 * @property `subjectId` 专题id
 */
export interface ParamssubjectsSubjectIdDeleteArticlesUsingDelete {
  // pathParams
  /**
   * 专题id
   */
  subjectId: number;
}
/**
 * 文章id数组
 */
export type ParamsBodysubjectsSubjectIdDeleteArticlesUsingDelete = Array<number>;
/**
 * @description subjectsSubjectIdFocusUsingPost参数
 * @property `subjectId` 专题id
 * @property `status` 关注状态(0关注,1取关)
 */
export interface ParamssubjectsSubjectIdFocusUsingPost {
  // pathParams
  /**
   * 专题id
   */
  subjectId: number;
  // queryParams
  /**
   * 关注状态(0关注,1取关)
   */
  status: number;
}
/**
 * @description subjectsSubjectIdUsingGet参数
 * @property `subjectId` 专题id
 */
export interface ParamssubjectsSubjectIdUsingGet {
  // pathParams
  /**
   * 专题id
   */
  subjectId: number;
}
/**
 * @description subjectsSubjectIdUsingPut参数
 * @property `subjectId` subjectId
 */
export interface ParamssubjectsSubjectIdUsingPut {
  // pathParams
  /**
   * subjectId
   */
  subjectId: number;
}
/**
 * subjectVO
 */
export type ParamsBodysubjectsSubjectIdUsingPut = models.SubjectVO;
/**
 * 专题id列表
 */
export type ParamsBodysubjectsUsingDelete = Array<number>;
/**
 * subjectVO
 */
export type ParamsBodysubjectsUsingPost = models.SubjectVO;
export class SubjectApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 获取专题列表
   * @param params ParamssubjectsListUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSubjectVO
   */
  public subjectsListUsingGet = (
    params: ParamssubjectsListUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSubjectVO> => {
    const path = '/api/subjects/list';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 批量添加专题文章
   * @param params ParamssubjectsSubjectIdAddArticlesUsingPost
   * @param data: ParamsBodysubjectsSubjectIdAddArticlesUsingPost// 文章id数组
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public subjectsSubjectIdAddArticlesUsingPost = (
    params: ParamssubjectsSubjectIdAddArticlesUsingPost,
    data: ParamsBodysubjectsSubjectIdAddArticlesUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/subjects/{subjectId}/addArticles';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.subjectId, 'subjectId');
    p.data = data;
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取专题文章列表
   * @param params ParamssubjectsSubjectIdArticlesUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultSingleArticleInfo
   */
  public subjectsSubjectIdArticlesUsingGet = (
    params: ParamssubjectsSubjectIdArticlesUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultSingleArticleInfo> => {
    const path = '/api/subjects/{subjectId}/articles';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('classifyId' in params) p.query.classifyId = params.classifyId;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('tagId' in params) p.query.tagId = params.tagId;
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.subjectId, 'subjectId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 批量删除专题文章
   * @param params ParamssubjectsSubjectIdDeleteArticlesUsingDelete
   * @param data: ParamsBodysubjectsSubjectIdDeleteArticlesUsingDelete// 文章id数组
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public subjectsSubjectIdDeleteArticlesUsingDelete = (
    params: ParamssubjectsSubjectIdDeleteArticlesUsingDelete,
    data: ParamsBodysubjectsSubjectIdDeleteArticlesUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/subjects/{subjectId}/deleteArticles';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.subjectId, 'subjectId');
    p.data = data;
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 关注/取消关注专题
   * @param params ParamssubjectsSubjectIdFocusUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public subjectsSubjectIdFocusUsingPost = (
    params: ParamssubjectsSubjectIdFocusUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/subjects/{subjectId}/focus';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('status' in params) p.query.status = params.status;
    ajax.check(params.status, 'status');
    ajax.check(params.subjectId, 'subjectId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取专题详情
   * @param params ParamssubjectsSubjectIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultSubjectVO
   */
  public subjectsSubjectIdUsingGet = (
    params: ParamssubjectsSubjectIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultSubjectVO> => {
    const path = '/api/subjects/{subjectId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.subjectId, 'subjectId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 更新专题
   * @param params ParamssubjectsSubjectIdUsingPut
   * @param data: ParamsBodysubjectsSubjectIdUsingPut// subjectVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public subjectsSubjectIdUsingPut = (
    params: ParamssubjectsSubjectIdUsingPut,
    data: ParamsBodysubjectsSubjectIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/subjects/{subjectId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.subjectId, 'subjectId');
    p.data = data;
    ajax.check(data, 'body.subjectVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 批量删除专题
   
   * @param data: ParamsBodysubjectsUsingDelete// 专题id列表
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public subjectsUsingDelete = (
    data: ParamsBodysubjectsUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/subjects';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 新增专题
   
   * @param data: ParamsBodysubjectsUsingPost// subjectVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public subjectsUsingPost = (
    data: ParamsBodysubjectsUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/subjects';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.subjectVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new SubjectApi();
